// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from '@/router'
import store from '@/store'
import { CHECK_AUTH } from '@/store/actions.type'

import ApiService from '@/common/api.service'
import ErrorFilter from '@/common/error.filter'

// Plugins - css + library imports
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

import 'font-awesome/css/font-awesome.css';
import '@/assets/scss/custom.scss'

import 'es6-promise/auto'

// plugin setup
import lang from 'element-ui/lib/locale/lang/es'
import locale from 'element-ui/lib/locale'
import VueCroppie from 'vue-croppie';

// Charts
import VueFusionCharts from 'vue-fusioncharts';
// import FusionCharts modules and resolve dependency
import FusionCharts from 'fusioncharts/core'
import Pie2D from 'fusioncharts/viz/pie2d'
import dragColumn2D from 'fusioncharts/viz/dragcolumn2d'
//import the theme
import FusionTheme from 'fusioncharts/themes/fusioncharts.theme.fusion'
// register VueFusionCharts component
Vue.use(VueFusionCharts, FusionCharts, Pie2D, FusionTheme, dragColumn2D);

// configure language
Vue.config.productionTip = false


Vue.filter('error', ErrorFilter)

locale.use(lang)
Vue.use(ElementUI)
Vue.use(VueCroppie);

ApiService.init()
router.beforeEach((to, from, next) => {
	if (to.matched.some(record => record.meta.requiresAuth)) {
		if (!store.state.auth.isAuthenticated) {
			next({
				path: '/Login',
				query: { replace: to.fullPath }
			})
		} else {
			next()
		}
	} else {
		next()
	}
})

/* eslint-disable no-new */
var vm = new Vue({
    el: '#app',
    router,
    store,
    render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js